<template>
    <div class="bubble-bottom">
        <svg data-name="Bubbles-Smiles - LG_TB" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 230.815">
            <defs>
                <clipPath id="8ktfifnqda">
                    <path data-name="Path 332" d="m490.1 573.326 2.359 230.815H1770.1l-2.359-230.815z"
                        transform="translate(-490.096 -573.326)"></path>
                </clipPath>
            </defs>
            <g style="clip-path: url(&quot;#8ktfifnqda&quot;);">
                <path data-name="Path 283"
                    d="M1185.083 605.879a4.578 4.578 0 1 0 2.837 5.831v-.009a4.579 4.579 0 0 0-2.839-5.822"
                    transform="translate(-459.635 -571.898)"></path>
                <path data-name="Path 284"
                    d="M1449.755 622.645a4.578 4.578 0 1 0 2.837 5.831v-.009a4.581 4.581 0 0 0-2.84-5.822"
                    transform="translate(-447.932 -571.156)"></path>
                <path data-name="Path 285"
                    d="M1309.453 622.645a4.578 4.578 0 1 0 2.837 5.831v-.009a4.581 4.581 0 0 0-2.84-5.822"
                    transform="translate(-454.135 -571.156)"></path>
                <path data-name="Path 286"
                    d="M1564.322 646.7a4.577 4.577 0 1 0 2.837 5.831v-.009a4.581 4.581 0 0 0-2.84-5.822"
                    transform="translate(-442.866 -570.093)"></path>
                <path data-name="Path 287"
                    d="M1692.407 637.933a4.578 4.578 0 1 0 2.837 5.832v-.01a4.579 4.579 0 0 0-2.839-5.821"
                    transform="translate(-437.203 -570.48)"></path>
                <path data-name="Path 288"
                    d="M1352.776 656.559a5.991 5.991 0 0 0-11.982-.034v.005a5.991 5.991 0 0 0 11.982.029"
                    transform="translate(-452.482 -569.911)"></path>
                <path data-name="Path 289"
                    d="M1504.117 667a5.991 5.991 0 0 0-11.982-.034v.005a5.991 5.991 0 0 0 11.982.029"
                    transform="translate(-445.79 -569.45)"></path>
                <path data-name="Path 290"
                    d="M1174.688 661.386a5.992 5.992 0 0 0-11.984-.034v.005a5.992 5.992 0 0 0 11.984.029"
                    transform="translate(-460.356 -569.698)"></path>
                <path data-name="Path 291"
                    d="M1264.06 646.875a9.32 9.32 0 1 0-18.639-.054v.008a9.32 9.32 0 0 0 18.639.046"
                    transform="translate(-456.698 -570.487)"></path>
                <path data-name="Path 292"
                    d="M1363.936 711.808a17.351 17.351 0 0 0-17.405 17.293v.034a17.348 17.348 0 1 0 17.405-17.328"
                    transform="translate(-452.228 -567.203)"></path>
                <path data-name="Path 293"
                    d="M1538.576 697.354a17.351 17.351 0 0 0-17.4 17.292v.033a17.347 17.347 0 1 0 17.4-17.326"
                    transform="translate(-444.506 -567.842)"></path>
                <path data-name="Path 294"
                    d="M1604.6 755.39a17.351 17.351 0 0 0-17.405 17.293v.035a17.348 17.348 0 1 0 17.405-17.328"
                    transform="translate(-441.587 -565.276)"></path>
                <path data-name="Path 295"
                    d="M1199.166 753.843h-.018a43.238 43.238 0 0 0-43.162 43.311v.116a43.3 43.3 0 1 0 43.177-43.427"
                    transform="translate(-460.653 -565.344)"></path>
                <path data-name="Path 296"
                    d="M1522.881 753.843h-.018a43.238 43.238 0 0 0-43.162 43.311v.116a43.3 43.3 0 1 0 43.177-43.427"
                    transform="translate(-446.34 -565.344)"></path>
                <path data-name="Path 297"
                    d="M1302.09 744.338h-.029a28.842 28.842 0 0 0-28.8 28.883v.071a28.89 28.89 0 1 0 28.827-28.954"
                    transform="translate(-455.468 -565.765)"></path>
                <path data-name="Path 298"
                    d="M1410.183 771.258h-.028a28.842 28.842 0 0 0-28.8 28.883v.071a28.89 28.89 0 1 0 28.826-28.954"
                    transform="translate(-450.688 -564.574)"></path>
                <path data-name="Path 299" d="M1406.2 666.149a12.279 12.279 0 1 0-.006-.014z"
                    transform="translate(-449.636 -569.995)"></path>
                <path data-name="Path 300" d="M1661.616 683.5a12.192 12.192 0 1 0-.006-.014z"
                    transform="translate(-438.343 -569.228)"></path>
                <path data-name="Path 301" d="M1284.936 697.231a12.172 12.172 0 1 0-.006-.014z"
                    transform="translate(-454.998 -568.621)"></path>
                <path data-name="Path 302"
                    d="M1233.2 678.508a27.8 27.8 0 0 0-26.446 48.9 27.76 27.76 0 0 0 37.638-11.164c.011-.023.023-.043.036-.066a27.8 27.8 0 0 0-11.229-37.675m5.227 34.434c-6.34 9.431-18.11 12.362-27.654 7.167s-13.536-16.713-9.057-27.165a.87.87 0 0 1 1.067-.487l2.175.71a.866.866 0 0 1 .521 1.171 16.962 16.962 0 0 0 29.734 16.2.866.866 0 0 1 1.267-.2l1.776 1.441a.869.869 0 0 1 .171 1.16"
                    transform="translate(-459.053 -568.823)"></path>
                <path data-name="Path 303"
                    d="M1617.585 669a18.884 18.884 0 0 0-17.966 33.221 18.857 18.857 0 0 0 25.569-7.584l.024-.044a18.885 18.885 0 0 0-7.627-25.593m3.551 23.393a14.233 14.233 0 0 1-24.94-13.585.591.591 0 0 1 .726-.33l1.478.482a.586.586 0 0 1 .353.795 11.523 11.523 0 0 0 20.2 11.006.588.588 0 0 1 .86-.135l1.207.978a.591.591 0 0 1 .116.788"
                    transform="translate(-441.475 -569.196)"></path>
                <path data-name="Path 304"
                    d="M1479.911 711.2a32.336 32.336 0 1 0-19.654 41.292h.005a32.293 32.293 0 0 0 19.679-41.212l-.028-.081m-22.829 32.132c-11.927 4.2-24.984-1.327-30.525-13.34a1.011 1.011 0 0 1 .412-1.3l2.307-1.325a1 1 0 0 1 1.417.462 19.842 19.842 0 0 0 24.771 10.935c9.7-3.413 15.073-13.569 12.391-24a1.007 1.007 0 0 1 .816-1.249l2.628-.412a1.013 1.013 0 0 1 1.136.756c3.207 12.825-3.43 25.276-15.353 29.474"
                    transform="translate(-449.108 -568.182)"></path>
                <path data-name="Path 305"
                    d="M1726.35 735.494a32.336 32.336 0 1 0-19.654 41.291 32.293 32.293 0 0 0 19.679-41.212l-.028-.081m-22.829 32.132c-11.927 4.2-24.984-1.327-30.525-13.34a1.011 1.011 0 0 1 .412-1.3l2.307-1.325a1 1 0 0 1 1.417.462 19.842 19.842 0 0 0 24.771 10.935c9.7-3.412 15.073-13.569 12.391-24a1.007 1.007 0 0 1 .816-1.249l2.628-.412a1.012 1.012 0 0 1 1.136.756c3.207 12.825-3.43 25.276-15.353 29.474"
                    transform="translate(-438.211 -567.107)"></path>
                <path data-name="Path 306"
                    d="M607.09 605.879a4.578 4.578 0 1 0 2.837 5.831v-.009a4.581 4.581 0 0 0-2.84-5.822"
                    transform="translate(-485.191 -571.898)"></path>
                <path data-name="Path 307"
                    d="M871.761 622.645a4.578 4.578 0 1 0 2.837 5.831v-.009a4.581 4.581 0 0 0-2.84-5.822"
                    transform="translate(-473.488 -571.156)"></path>
                <path data-name="Path 308"
                    d="M731.46 622.645a4.578 4.578 0 1 0 2.836 5.831v-.009a4.581 4.581 0 0 0-2.84-5.822"
                    transform="translate(-479.692 -571.156)"></path>
                <path data-name="Path 309"
                    d="M986.328 646.7a4.577 4.577 0 1 0 2.837 5.831v-.009a4.581 4.581 0 0 0-2.84-5.822"
                    transform="translate(-468.423 -570.093)"></path>
                <path data-name="Path 310"
                    d="M1114.414 637.933a4.578 4.578 0 1 0 2.836 5.832v-.01a4.579 4.579 0 0 0-2.839-5.821"
                    transform="translate(-462.759 -570.48)"></path>
                <path data-name="Path 311"
                    d="M774.782 656.559a5.991 5.991 0 0 0-11.982-.034v.005a5.991 5.991 0 0 0 11.982.029"
                    transform="translate(-478.038 -569.911)"></path>
                <path data-name="Path 312"
                    d="M926.124 667a5.992 5.992 0 0 0-11.983-.034v.005a5.992 5.992 0 0 0 11.983.029"
                    transform="translate(-471.346 -569.45)"></path>
                <path data-name="Path 313"
                    d="M596.693 661.386a5.991 5.991 0 1 0-11.982-.034v.005a5.991 5.991 0 0 0 11.982.029"
                    transform="translate(-485.913 -569.698)"></path>
                <path data-name="Path 314"
                    d="M686.066 646.875a9.32 9.32 0 1 0-18.639-.054v.008a9.32 9.32 0 0 0 18.639.046"
                    transform="translate(-482.255 -570.487)"></path>
                <path data-name="Path 315"
                    d="M785.942 711.808a17.351 17.351 0 0 0-17.405 17.292v.034a17.348 17.348 0 1 0 17.405-17.328"
                    transform="translate(-477.784 -567.203)"></path>
                <path data-name="Path 316"
                    d="M960.583 697.354a17.351 17.351 0 0 0-17.4 17.292v.033a17.347 17.347 0 1 0 17.4-17.326"
                    transform="translate(-470.062 -567.842)"></path>
                <path data-name="Path 317"
                    d="M1026.6 755.39a17.351 17.351 0 0 0-17.4 17.293v.035a17.348 17.348 0 1 0 17.4-17.328"
                    transform="translate(-467.143 -565.276)"></path>
                <path data-name="Path 318"
                    d="M621.172 753.843h-.018a43.238 43.238 0 0 0-43.162 43.311v.116a43.3 43.3 0 1 0 43.177-43.427"
                    transform="translate(-486.21 -565.344)"></path>
                <path data-name="Path 319"
                    d="M944.887 753.843h-.018a43.238 43.238 0 0 0-43.162 43.311v.116a43.3 43.3 0 1 0 43.177-43.427"
                    transform="translate(-471.896 -565.344)"></path>
                <path data-name="Path 320"
                    d="M724.1 744.338h-.028a28.842 28.842 0 0 0-28.8 28.883v.071a28.89 28.89 0 1 0 28.828-28.954"
                    transform="translate(-481.024 -565.765)"></path>
                <path data-name="Path 321"
                    d="M832.189 771.258h-.028a28.842 28.842 0 0 0-28.8 28.883v.071a28.89 28.89 0 1 0 28.826-28.954"
                    transform="translate(-476.245 -564.574)"></path>
                <path data-name="Path 322" d="M828.208 666.149a12.236 12.236 0 1 0-.006-.014z"
                    transform="translate(-475.193 -569.995)"></path>
                <path data-name="Path 323" d="M1083.623 683.5a12.279 12.279 0 1 0-.006-.014z"
                    transform="translate(-463.899 -569.228)"></path>
                <path data-name="Path 324" d="M706.942 697.231a12.215 12.215 0 1 0-.006-.014z"
                    transform="translate(-480.555 -568.621)"></path>
                <path data-name="Path 325"
                    d="M655.2 678.508a27.8 27.8 0 0 0-26.446 48.9 27.76 27.76 0 0 0 37.638-11.164c.011-.023.023-.043.036-.066a27.8 27.8 0 0 0-11.228-37.67m5.227 34.434c-6.34 9.431-18.11 12.362-27.654 7.167s-13.536-16.713-9.058-27.165a.87.87 0 0 1 1.067-.487l2.175.71a.865.865 0 0 1 .52 1.171 16.963 16.963 0 0 0 29.735 16.2.866.866 0 0 1 1.267-.2l1.776 1.441a.869.869 0 0 1 .171 1.16"
                    transform="translate(-484.61 -568.823)"></path>
                <path data-name="Path 326"
                    d="M1039.591 669a18.884 18.884 0 0 0-17.966 33.221 18.858 18.858 0 0 0 25.569-7.584l.024-.044a18.885 18.885 0 0 0-7.627-25.593m3.551 23.393a14.233 14.233 0 0 1-24.939-13.585.59.59 0 0 1 .725-.33l1.478.482a.587.587 0 0 1 .354.795 11.523 11.523 0 0 0 20.2 11.006.588.588 0 0 1 .861-.135l1.207.978a.591.591 0 0 1 .116.788"
                    transform="translate(-467.032 -569.196)"></path>
                <path data-name="Path 327"
                    d="M901.917 711.2a32.336 32.336 0 1 0-19.654 41.292h.005a32.293 32.293 0 0 0 19.679-41.212l-.028-.081m-22.829 32.132c-11.928 4.2-24.984-1.327-30.525-13.34a1.011 1.011 0 0 1 .412-1.3l2.307-1.325a1 1 0 0 1 1.417.462 19.842 19.842 0 0 0 24.771 10.935c9.7-3.413 15.073-13.569 12.391-24a1.007 1.007 0 0 1 .816-1.249l2.628-.412a1.012 1.012 0 0 1 1.136.756c3.207 12.825-3.43 25.276-15.353 29.474"
                    transform="translate(-474.664 -568.182)"></path>
                <path data-name="Path 328"
                    d="M1148.357 735.494a32.336 32.336 0 1 0-19.654 41.291h.005a32.293 32.293 0 0 0 19.679-41.212l-.028-.081m-22.829 32.132c-11.927 4.2-24.984-1.327-30.524-13.34a1.011 1.011 0 0 1 .412-1.3l2.307-1.325a1 1 0 0 1 1.417.462 19.842 19.842 0 0 0 24.771 10.935c9.7-3.412 15.073-13.569 12.391-24a1.007 1.007 0 0 1 .816-1.249l2.628-.412a1.012 1.012 0 0 1 1.136.756c3.207 12.825-3.43 25.276-15.353 29.474"
                    transform="translate(-463.768 -567.107)"></path>
                <path data-name="Path 329"
                    d="M536.42 637.933a4.577 4.577 0 1 0 2.836 5.832v-.01a4.581 4.581 0 0 0-2.84-5.821"
                    transform="translate(-488.316 -570.48)"></path>
                <path data-name="Path 330" d="M505.629 683.5a12.235 12.235 0 1 0-.006-.014z"
                    transform="translate(-489.456 -569.228)"></path>
                <path data-name="Path 331"
                    d="M570.363 735.494a32.336 32.336 0 1 0-19.654 41.291h.005a32.293 32.293 0 0 0 19.679-41.212l-.028-.081m-22.829 32.132c-11.928 4.2-24.984-1.327-30.525-13.34a1.011 1.011 0 0 1 .412-1.3l2.307-1.325a1 1 0 0 1 1.417.462 19.842 19.842 0 0 0 24.771 10.935c9.7-3.412 15.073-13.569 12.391-24a1.007 1.007 0 0 1 .816-1.249l2.628-.412a1.012 1.012 0 0 1 1.136.756c3.207 12.825-3.43 25.276-15.353 29.474"
                    transform="translate(-489.325 -567.107)"></path>
            </g>
        </svg>
    </div>
</template>

<script>

export default {
    name: "bubble-bottom",
}
</script>

<style lang=scss>
.bubble-bottom {
    width: 100%;

    svg {
        display: block;
    }

    @media (max-width: 768px) {
        padding-top: 2em;
    }

}
</style>


// WEBPACK FOOTER //
// src/components/mixology/BubbleBottom.vue